import find from 'lodash/find';
import get from 'lodash/get';

/**
 * getMembersWithProjectInfo
 * helper function that returns the members with the project info
 */
export const getMembersWithProjectInfo = (props = {}) => {
  const { members, project, projectRoles } = props;

  return members
    .map((member) => {
      const projectMembership = find(member.projectMemberships, { projectId: project.id });
      return {
        ...member,
        inProject: !!projectMembership,
        projectRole: get(
          find(projectRoles, {
            id: get(projectMembership, 'roleId'),
          }),
          'name',
        ),
      };
    })
    .sort((a, b) => (a.inProject && !b.inProject ? -1 : 1));
};
